import { render, staticRenderFns } from "./RemandExpand.vue?vue&type=template&id=65ce80bb&"
import script from "./RemandExpand.vue?vue&type=script&lang=ts&"
export * from "./RemandExpand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports